import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';
import { App as NativeApp } from '@capacitor/app';
import { apiFetch } from '../lib/apiFetch';

export const isNative=()=>Capacitor.isNativePlatform();
export const flavor=process.env.REACT_APP_MOBILE_FLAVOR;
export const mobileScheme=process.env.REACT_APP_MOBILE_SCHEME;
const PENDING='necs-mobile-sign-in';
const base64url=bytes=>btoa(String.fromCharCode(...new Uint8Array(bytes))).replace(/\+/g,'-').replace(/\//g,'_').replace(/=+$/,'');

export async function startMobileSignIn(){
  if(!['staff','resident'].includes(flavor)||!mobileScheme)throw new Error('Mobile app configuration is missing.');
  const verifier=base64url(crypto.getRandomValues(new Uint8Array(32)));
  const challenge=base64url(await crypto.subtle.digest('SHA-256',new TextEncoder().encode(verifier)));
  const result=await apiFetch('/api/auth/mobile/start',{method:'POST',body:{flavor,challenge}});
  sessionStorage.setItem(PENDING,JSON.stringify({verifier,request_id:result.request_id}));
  await Browser.open({url:new URL(result.authorization_path,process.env.REACT_APP_BACKEND_URL).toString()});
}

export async function watchMobileSignIn(onSuccess,onError){
  let exchanging=false;
  const consume=async raw=>{
    let url;try{url=new URL(raw);}catch{return;}
    if(url.protocol!==`${mobileScheme}:`||url.hostname!=='auth'||exchanging)return;
    try{
      const pending=JSON.parse(sessionStorage.getItem(PENDING)||'null');
      if(!pending||url.searchParams.get('request_id')!==pending.request_id)throw new Error('This sign-in request is no longer active. Start sign-in again.');
      exchanging=true;
      await apiFetch('/api/auth/mobile/exchange',{method:'POST',body:{request_id:pending.request_id,verifier:pending.verifier,code:url.searchParams.get('code')}});
      sessionStorage.removeItem(PENDING);
      await Browser.close().catch(()=>{});
      await apiFetch('/api/auth/me'); // Confirm the native HttpOnly cookie jar, not merely exchange success.
      await onSuccess();
    }catch(e){onError(typeof e.detail==='string'?e.detail:e.message||'Mobile sign-in could not finish. Please retry.');}
    finally{exchanging=false;}
  };
  const handle=await NativeApp.addListener('appUrlOpen',event=>consume(event.url));
  const launch=await NativeApp.getLaunchUrl();if(launch?.url)await consume(launch.url);
  return ()=>handle.remove();
}